// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskDetail_container__CkCP3 {
  position: relative;
  width: 100%;
  padding: 16px;
}

.TaskDetail_embedded__ALZbp {
  padding: 0;
}

.TaskDetail_layout__jDH27 {
  display: grid;
  grid-template-columns: minmax(320px, 440px) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

.TaskDetail_leftPanel__efNZY,
.TaskDetail_rightPanel__JUxBY {
  background: var(--cl-surface, #fff);
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 14px;
  padding: 16px;
}

.TaskDetail_leftPanel__efNZY {
  position: sticky;
  top: 12px;
  max-height: calc(100vh - 32px);
  overflow: auto;
  -webkit-user-select: text;
          user-select: text;
}

.TaskDetail_leftPanel__efNZY h1 {
  margin-bottom: 16px;
  font-size: 24px;
  line-height: 1.25;
}

.TaskDetail_titleInline__VDz5R {
  font-size: inherit;
  font-weight: 800;
  line-height: inherit;
}

.TaskDetail_terminalPaymentBadge__4mQeL {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  margin: 0 0 16px;
  padding: 6px 10px;
  border: 1px solid #fbcfe8;
  border-radius: 8px;
  background: #fce7f3;
  color: #be185d;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.TaskDetail_field__fDvaT {
  margin-bottom: 14px;
  -webkit-user-select: text;
          user-select: text;
}

.TaskDetail_field__fDvaT label {
  font-weight: 700;
  display: block;
  margin-bottom: 6px;
}

.TaskDetail_field__fDvaT p {
  margin: 0;
  line-height: 1.35;
  word-break: break-word;
}

.TaskDetail_softwareLine__JDDr\\+ {
  margin-top: 6px;
  color: var(--cl-dark, #5f6b7a);
  font-size: 12px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.TaskDetail_internalCommentField__H1lyS {
  padding: 12px;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  background: #eff6ff;
}

.TaskDetail_internalCommentTextarea__g1yyX {
  display: block;
  width: 100%;
  min-height: 96px;
  padding: 10px 12px;
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 8px;
  background: #fff;
  color: inherit;
  font: inherit;
  line-height: 1.4;
  resize: vertical;
  box-sizing: border-box;
}

.TaskDetail_internalCommentTextarea__g1yyX:focus {
  border-color: #1677ff;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.12);
}

.TaskDetail_internalCommentActions__\\+0Vur {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.TaskDetail_primarySmallButton__fXlT5,
.TaskDetail_secondarySmallButton__4Z9tW {
  min-height: 34px;
  padding: 7px 12px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
}

.TaskDetail_primarySmallButton__fXlT5 {
  background: #1677ff;
  color: #fff;
}

.TaskDetail_secondarySmallButton__4Z9tW {
  border-color: var(--cl-border, #d8dde6);
  background: #fff;
  color: var(--cl-dark, #5f6b7a);
}

.TaskDetail_primarySmallButton__fXlT5:disabled,
.TaskDetail_secondarySmallButton__4Z9tW:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.TaskDetail_addressHistoryAddress__au\\+Jb {
  margin-bottom: 8px !important;
  color: var(--cl-dark, #5f6b7a);
  font-size: 12px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.TaskDetail_addressHistoryDropdown__QovEN {
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 8px;
  background: var(--cl-surface-2, #f6f8fb);
  overflow: hidden;
}

.TaskDetail_addressHistoryDropdown__QovEN summary {
  min-height: 38px;
  padding: 10px 12px;
  cursor: pointer;
  font-weight: 700;
  line-height: 1.25;
  list-style-position: inside;
}

.TaskDetail_addressHistoryList__EeZmV {
  display: grid;
  gap: 8px;
  padding: 0 10px 10px;
}

.TaskDetail_addressHistoryItem__U0rwT {
  display: grid;
  gap: 5px;
  width: 100%;
  padding: 10px;
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 8px;
  background: #fff;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.TaskDetail_addressHistoryItem__U0rwT:hover,
.TaskDetail_addressHistoryItem__U0rwT:focus-visible {
  border-color: #1677ff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.12);
}

.TaskDetail_addressHistoryTopline__OyZ3u {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.TaskDetail_addressHistoryStatus__bckc5 {
  display: inline-flex;
  align-items: center;
  max-width: 58%;
  padding: 3px 7px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #075985;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.TaskDetail_addressHistoryStatusClosed__ijhKN {
  background: #e5e7eb;
  color: #4b5563;
}

.TaskDetail_addressHistoryTitle__HBCh7 {
  color: var(--cl-text, #111827);
  font-weight: 700;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.TaskDetail_addressHistoryMeta__-ZAIo {
  color: var(--cl-dark, #5f6b7a);
  font-size: 12px;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.TaskDetail_field__fDvaT strong {
  font-weight: 700;
}

.TaskDetail_field__fDvaT a {
  word-break: break-word;
}

.TaskDetail_field__fDvaT ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.TaskDetail_field__fDvaT li {
  margin-bottom: 6px;
}

.TaskDetail_supportCard__n5-zs {
  display: grid;
  gap: 8px;
  padding: 12px;
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 12px;
  background: var(--cl-surface-2, #f6f8fb);
}

.TaskDetail_terminalList__N-ksv {
  display: grid;
  gap: 10px;
  margin-top: 10px;
}

.TaskDetail_terminalCard__SHeYf {
  display: grid;
  gap: 6px;
  padding: 12px;
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 12px;
  background: #fff;
}

.TaskDetail_terminalLogRequest__2hDHe {
  display: grid;
  gap: 7px;
  margin-top: 6px;
  padding-top: 10px;
  border-top: 1px solid var(--cl-border, #d8dde6);
}

.TaskDetail_terminalLogRequestHeader__k2Jip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.TaskDetail_terminalLogStatus__yI-Td {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
}

.TaskDetail_terminalLogStatusActive__Lf7PY {
  background: #e0f2fe;
  color: #075985;
}

.TaskDetail_terminalLogStatusReady__ZpVkJ {
  background: #dcfce7;
  color: #166534;
}

.TaskDetail_terminalLogStatusError__zT5Qu {
  background: #fee2e2;
  color: #991b1b;
}

.TaskDetail_terminalLogError__lFBiD {
  color: #b91c1c;
  font-size: 12px;
}

.TaskDetail_terminalLogActions__CvZuP {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 2px;
}

.TaskDetail_auditList__sbqTx {
  display: grid;
  gap: 10px;
}

.TaskDetail_presenceList__7en\\+a {
  display: grid;
  gap: 8px;
}

.TaskDetail_presenceItem__X6Cat {
  display: grid;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 12px;
  background: var(--cl-surface-2, #f6f8fb);
}

.TaskDetail_auditItem__nG4EK {
  display: grid;
  gap: 6px;
  padding: 12px;
  border: 1px solid var(--cl-border, #d8dde6);
  border-radius: 12px;
  background: #fff;
}

.TaskDetail_supportHint__lhBB\\+ {
  margin-top: 10px !important;
  color: var(--cl-dark, #5f6b7a);
  opacity: 0.85;
}

.TaskDetail_ratingBox__h1CBr {
  display: grid;
  gap: 10px;
  margin-bottom: 14px;
  padding: 12px;
  border: 1px solid #fde68a;
  border-radius: 8px;
  background: #fffbeb;
}

.TaskDetail_ratingHeader__qEjWO {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.TaskDetail_ratingHeader__qEjWO label {
  margin: 0;
  font-weight: 800;
}

.TaskDetail_ratingHeader__qEjWO span {
  color: #92400e;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}

.TaskDetail_ratingButtons__cDwpZ {
  display: grid;
  grid-template-columns: repeat(5, minmax(36px, 1fr));
  gap: 6px;
}

.TaskDetail_ratingButton__NYha- {
  min-height: 36px;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  background: #fff;
  color: #92400e;
  font-weight: 800;
  cursor: pointer;
}

.TaskDetail_ratingButton__NYha-:hover,
.TaskDetail_ratingButton__NYha-:focus-visible,
.TaskDetail_ratingButtonActive__8IcUY {
  background: #f59e0b;
  color: #fff;
  outline: none;
}

.TaskDetail_ratingButton__NYha-:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.TaskDetail_ratingReadonly__ft058 {
  margin: 0 !important;
  color: #92400e;
  font-size: 13px;
}

.TaskDetail_placeholder__sGJpH {
  border: 1px dashed var(--cl-border, #d8dde6);
  border-radius: 14px;
  background: var(--cl-surface, #fff);
  padding: 28px 22px;
  color: var(--cl-dark, #5f6b7a);
}

.TaskDetail_buttonsContainer__xsqNL {
  display: flex;
  gap: 10px;
  margin-top: 18px;
  flex-wrap: wrap;
}

.TaskDetail_buttonsContainer__xsqNL button {
  padding: 10px 16px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  min-height: 44px;
}

.TaskDetail_buttonsContainer__xsqNL button:first-of-type {
  background-color: #1677ff;
  color: #fff;
}

.TaskDetail_buttonsContainer__xsqNL button:last-of-type {
  background-color: #6c757d;
  color: #fff;
}

@media (max-width: 1100px) {
  .TaskDetail_layout__jDH27 {
    grid-template-columns: 1fr;
  }
  .TaskDetail_leftPanel__efNZY {
    position: static;
    max-height: none;
  }
}
@media (max-width: 768px) {
  .TaskDetail_container__CkCP3 {
    padding: 10px;
  }
  .TaskDetail_leftPanel__efNZY,
  .TaskDetail_rightPanel__JUxBY {
    padding: 12px;
  }
  .TaskDetail_leftPanel__efNZY h1 {
    font-size: 19px;
    margin-bottom: 12px;
  }
  .TaskDetail_buttonsContainer__xsqNL button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Task/TaskDetail.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,aAAA;EACA,0DAAA;EACA,SAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,mCAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;UAAA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,UAAA;EACA,8CAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;;EAEE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,uCAAA;EACA,gBAAA;EACA,8BAAA;AACF;;AAEA;;EAEE,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,6BAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,2CAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,qBAAA;EACA,aAAA;EACA,8CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,+CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,2BAAA;EACA,8BAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mDAAA;EACA,QAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;;;EAGE,mBAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,oBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,4CAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;AACF;;AAEA;EACE;IACE,0BAAA;EACF;EAEA;IACE,gBAAA;IACA,gBAAA;EAAF;AACF;AAGA;EACE;IACE,aAAA;EADF;EAIA;;IAEE,aAAA;EAFF;EAKA;IACE,eAAA;IACA,mBAAA;EAHF;EAMA;IACE,WAAA;EAJF;AACF","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n  padding: 16px;\n}\n\n.embedded {\n  padding: 0;\n}\n\n.layout {\n  display: grid;\n  grid-template-columns: minmax(320px, 440px) minmax(0, 1fr);\n  gap: 16px;\n  align-items: start;\n}\n\n.leftPanel,\n.rightPanel {\n  background: var(--cl-surface, #fff);\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 14px;\n  padding: 16px;\n}\n\n.leftPanel {\n  position: sticky;\n  top: 12px;\n  max-height: calc(100vh - 32px);\n  overflow: auto;\n  user-select: text;\n}\n\n.leftPanel h1 {\n  margin-bottom: 16px;\n  font-size: 24px;\n  line-height: 1.25;\n}\n\n.titleInline {\n  font-size: inherit;\n  font-weight: 800;\n  line-height: inherit;\n}\n\n.terminalPaymentBadge {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  margin: 0 0 16px;\n  padding: 6px 10px;\n  border: 1px solid #fbcfe8;\n  border-radius: 8px;\n  background: #fce7f3;\n  color: #be185d;\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n\n.field {\n  margin-bottom: 14px;\n  user-select: text;\n}\n\n.field label {\n  font-weight: 700;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.field p {\n  margin: 0;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.softwareLine {\n  margin-top: 6px;\n  color: var(--cl-dark, #5f6b7a);\n  font-size: 12px;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.internalCommentField {\n  padding: 12px;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  background: #eff6ff;\n}\n\n.internalCommentTextarea {\n  display: block;\n  width: 100%;\n  min-height: 96px;\n  padding: 10px 12px;\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 8px;\n  background: #fff;\n  color: inherit;\n  font: inherit;\n  line-height: 1.4;\n  resize: vertical;\n  box-sizing: border-box;\n}\n\n.internalCommentTextarea:focus {\n  border-color: #1677ff;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.12);\n}\n\n.internalCommentActions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.primarySmallButton,\n.secondarySmallButton {\n  min-height: 34px;\n  padding: 7px 12px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.2;\n  cursor: pointer;\n}\n\n.primarySmallButton {\n  background: #1677ff;\n  color: #fff;\n}\n\n.secondarySmallButton {\n  border-color: var(--cl-border, #d8dde6);\n  background: #fff;\n  color: var(--cl-dark, #5f6b7a);\n}\n\n.primarySmallButton:disabled,\n.secondarySmallButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.58;\n}\n\n.addressHistoryAddress {\n  margin-bottom: 8px !important;\n  color: var(--cl-dark, #5f6b7a);\n  font-size: 12px;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.addressHistoryDropdown {\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 8px;\n  background: var(--cl-surface-2, #f6f8fb);\n  overflow: hidden;\n}\n\n.addressHistoryDropdown summary {\n  min-height: 38px;\n  padding: 10px 12px;\n  cursor: pointer;\n  font-weight: 700;\n  line-height: 1.25;\n  list-style-position: inside;\n}\n\n.addressHistoryList {\n  display: grid;\n  gap: 8px;\n  padding: 0 10px 10px;\n}\n\n.addressHistoryItem {\n  display: grid;\n  gap: 5px;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 8px;\n  background: #fff;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.addressHistoryItem:hover,\n.addressHistoryItem:focus-visible {\n  border-color: #1677ff;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.12);\n}\n\n.addressHistoryTopline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n}\n\n.addressHistoryStatus {\n  display: inline-flex;\n  align-items: center;\n  max-width: 58%;\n  padding: 3px 7px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #075985;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n\n.addressHistoryStatusClosed {\n  background: #e5e7eb;\n  color: #4b5563;\n}\n\n.addressHistoryTitle {\n  color: var(--cl-text, #111827);\n  font-weight: 700;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.addressHistoryMeta {\n  color: var(--cl-dark, #5f6b7a);\n  font-size: 12px;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n}\n\n.field strong {\n  font-weight: 700;\n}\n\n.field a {\n  word-break: break-word;\n}\n\n.field ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.field li {\n  margin-bottom: 6px;\n}\n\n.supportCard {\n  display: grid;\n  gap: 8px;\n  padding: 12px;\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 12px;\n  background: var(--cl-surface-2, #f6f8fb);\n}\n\n.terminalList {\n  display: grid;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.terminalCard {\n  display: grid;\n  gap: 6px;\n  padding: 12px;\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.terminalLogRequest {\n  display: grid;\n  gap: 7px;\n  margin-top: 6px;\n  padding-top: 10px;\n  border-top: 1px solid var(--cl-border, #d8dde6);\n}\n\n.terminalLogRequestHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.terminalLogStatus {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.terminalLogStatusActive {\n  background: #e0f2fe;\n  color: #075985;\n}\n\n.terminalLogStatusReady {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.terminalLogStatusError {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.terminalLogError {\n  color: #b91c1c;\n  font-size: 12px;\n}\n\n.terminalLogActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.auditList {\n  display: grid;\n  gap: 10px;\n}\n\n.presenceList {\n  display: grid;\n  gap: 8px;\n}\n\n.presenceItem {\n  display: grid;\n  gap: 4px;\n  padding: 10px 12px;\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 12px;\n  background: var(--cl-surface-2, #f6f8fb);\n}\n\n.auditItem {\n  display: grid;\n  gap: 6px;\n  padding: 12px;\n  border: 1px solid var(--cl-border, #d8dde6);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.supportHint {\n  margin-top: 10px !important;\n  color: var(--cl-dark, #5f6b7a);\n  opacity: 0.85;\n}\n\n.ratingBox {\n  display: grid;\n  gap: 10px;\n  margin-bottom: 14px;\n  padding: 12px;\n  border: 1px solid #fde68a;\n  border-radius: 8px;\n  background: #fffbeb;\n}\n\n.ratingHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.ratingHeader label {\n  margin: 0;\n  font-weight: 800;\n}\n\n.ratingHeader span {\n  color: #92400e;\n  font-size: 13px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.ratingButtons {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(36px, 1fr));\n  gap: 6px;\n}\n\n.ratingButton {\n  min-height: 36px;\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n  background: #fff;\n  color: #92400e;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.ratingButton:hover,\n.ratingButton:focus-visible,\n.ratingButtonActive {\n  background: #f59e0b;\n  color: #fff;\n  outline: none;\n}\n\n.ratingButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.58;\n}\n\n.ratingReadonly {\n  margin: 0 !important;\n  color: #92400e;\n  font-size: 13px;\n}\n\n.placeholder {\n  border: 1px dashed var(--cl-border, #d8dde6);\n  border-radius: 14px;\n  background: var(--cl-surface, #fff);\n  padding: 28px 22px;\n  color: var(--cl-dark, #5f6b7a);\n}\n\n.buttonsContainer {\n  display: flex;\n  gap: 10px;\n  margin-top: 18px;\n  flex-wrap: wrap;\n}\n\n.buttonsContainer button {\n  padding: 10px 16px;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  min-height: 44px;\n}\n\n.buttonsContainer button:first-of-type {\n  background-color: #1677ff;\n  color: #fff;\n}\n\n.buttonsContainer button:last-of-type {\n  background-color: #6c757d;\n  color: #fff;\n}\n\n@media (max-width: 1100px) {\n  .layout {\n    grid-template-columns: 1fr;\n  }\n\n  .leftPanel {\n    position: static;\n    max-height: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 10px;\n  }\n\n  .leftPanel,\n  .rightPanel {\n    padding: 12px;\n  }\n\n  .leftPanel h1 {\n    font-size: 19px;\n    margin-bottom: 12px;\n  }\n\n  .buttonsContainer button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TaskDetail_container__CkCP3`,
	"embedded": `TaskDetail_embedded__ALZbp`,
	"layout": `TaskDetail_layout__jDH27`,
	"leftPanel": `TaskDetail_leftPanel__efNZY`,
	"rightPanel": `TaskDetail_rightPanel__JUxBY`,
	"titleInline": `TaskDetail_titleInline__VDz5R`,
	"terminalPaymentBadge": `TaskDetail_terminalPaymentBadge__4mQeL`,
	"field": `TaskDetail_field__fDvaT`,
	"softwareLine": `TaskDetail_softwareLine__JDDr+`,
	"internalCommentField": `TaskDetail_internalCommentField__H1lyS`,
	"internalCommentTextarea": `TaskDetail_internalCommentTextarea__g1yyX`,
	"internalCommentActions": `TaskDetail_internalCommentActions__+0Vur`,
	"primarySmallButton": `TaskDetail_primarySmallButton__fXlT5`,
	"secondarySmallButton": `TaskDetail_secondarySmallButton__4Z9tW`,
	"addressHistoryAddress": `TaskDetail_addressHistoryAddress__au+Jb`,
	"addressHistoryDropdown": `TaskDetail_addressHistoryDropdown__QovEN`,
	"addressHistoryList": `TaskDetail_addressHistoryList__EeZmV`,
	"addressHistoryItem": `TaskDetail_addressHistoryItem__U0rwT`,
	"addressHistoryTopline": `TaskDetail_addressHistoryTopline__OyZ3u`,
	"addressHistoryStatus": `TaskDetail_addressHistoryStatus__bckc5`,
	"addressHistoryStatusClosed": `TaskDetail_addressHistoryStatusClosed__ijhKN`,
	"addressHistoryTitle": `TaskDetail_addressHistoryTitle__HBCh7`,
	"addressHistoryMeta": `TaskDetail_addressHistoryMeta__-ZAIo`,
	"supportCard": `TaskDetail_supportCard__n5-zs`,
	"terminalList": `TaskDetail_terminalList__N-ksv`,
	"terminalCard": `TaskDetail_terminalCard__SHeYf`,
	"terminalLogRequest": `TaskDetail_terminalLogRequest__2hDHe`,
	"terminalLogRequestHeader": `TaskDetail_terminalLogRequestHeader__k2Jip`,
	"terminalLogStatus": `TaskDetail_terminalLogStatus__yI-Td`,
	"terminalLogStatusActive": `TaskDetail_terminalLogStatusActive__Lf7PY`,
	"terminalLogStatusReady": `TaskDetail_terminalLogStatusReady__ZpVkJ`,
	"terminalLogStatusError": `TaskDetail_terminalLogStatusError__zT5Qu`,
	"terminalLogError": `TaskDetail_terminalLogError__lFBiD`,
	"terminalLogActions": `TaskDetail_terminalLogActions__CvZuP`,
	"auditList": `TaskDetail_auditList__sbqTx`,
	"presenceList": `TaskDetail_presenceList__7en+a`,
	"presenceItem": `TaskDetail_presenceItem__X6Cat`,
	"auditItem": `TaskDetail_auditItem__nG4EK`,
	"supportHint": `TaskDetail_supportHint__lhBB+`,
	"ratingBox": `TaskDetail_ratingBox__h1CBr`,
	"ratingHeader": `TaskDetail_ratingHeader__qEjWO`,
	"ratingButtons": `TaskDetail_ratingButtons__cDwpZ`,
	"ratingButton": `TaskDetail_ratingButton__NYha-`,
	"ratingButtonActive": `TaskDetail_ratingButtonActive__8IcUY`,
	"ratingReadonly": `TaskDetail_ratingReadonly__ft058`,
	"placeholder": `TaskDetail_placeholder__sGJpH`,
	"buttonsContainer": `TaskDetail_buttonsContainer__xsqNL`
};
export default ___CSS_LOADER_EXPORT___;
